import React from 'react';
import { useSpectatorStats } from '../hooks/spectators';
import SpectatorsRow from '../components/Spectators/SpectatorsRow';

function Spectators() {
  const [spectators, loading, error] = useSpectatorStats();

  if (loading || error) return <div>Laddar...</div>;

  return spectators.map((spectator, index) => (
    <SpectatorsRow stats={spectator} position={index + 1} />
  ));
}
export default Spectators;
